import {
    CREATE_RANGE,
    CREATE_RANGE_FAILED,
    RESET_FORMS
} from '../actions/types'

const initialState = {}

const createRangeReducer = (state = initialState, action) => {
    switch(action.type){
        case CREATE_RANGE:
            return {
                details: action.payload,
                success: 'Range created successfully',
            }
        case CREATE_RANGE_FAILED:
            return {
                ...state,
                errors: action.payload,
                success: null
            }
        case RESET_FORMS:
            return initialState
        default:
            return state
    }
}

export default createRangeReducer